export default{
    // webPath:'http://localhost:8081/'
    // webPath:'/deliverydb/'
    // webPath:process.env.NODE_ENV==='production'?'/deliverydb/':'http://localhost:8081/'
    // webPath:'http://kiosk1.totddns.com:34200/deliverydb/'
    // webPath:'http://kiosk2.thddns.net:5440/deliverydb/'
    webPath:process.env.NODE_ENV==='production'?'https://api.kioskthailand.com/deliverydb2/':'http://localhost:8081/',
    webPath2:'https://api.kioskthailand.com/deliverydb/',
    // Connection 3: same backend app as webPath2, but reached directly over the
    // office LAN instead of hairpinning out through AIS/TOT and back. Root-relative,
    // so it only resolves when the page itself is served by the IIS server -- hence
    // localHosts below, which gates the menu item. Never offered on Firebase Hosting,
    // where this path would be answered by the SPA rewrite with index.html at HTTP 200.
    webPath3:'/deliverydb/',
    // Hosts that serve the app from inside the office network. Positive allowlist:
    // an unrecognised host falls back to the internet route rather than a dead path.
    localHosts:['kioskserver','192.168.1.5'],
    // Domains a prefilled นัดหมาย (?appt=1) may report its result back to --
    // Kiosk Online Shop, which opens the booking form for an order whose SAP SO
    // does not exist yet. HTTPS only, the domain itself or any subdomain of it
    // (http is allowed on localhost, which is how that app is developed).
    //
    // Login already keeps strangers off the booking page, and the result carries
    // no customer detail, so this is not guarding the data. It stops a link
    // mailed to a signed-in member of staff from walking them to a lookalike
    // login page on the authority of the internal system. A refused address is
    // SAID so on the page, never silently dropped -- see R.apptReturn and
    // docs/kioskonlineshop-delivery-status.md.
    apptReturnDomains:[
      'kioskonlineshop2026.web.app',
      'kioskonlineshop2026.firebaseapp.com',
      'kioskthailand.com'
    ]
}
